import { isGroupTableQuery } from 'owa-group-utils';
import type { TableView } from 'owa-mail-list-store';
import { getFolderIdFromTableView } from 'owa-mail-search';
import { getFolderTable } from 'owa-folders';
import type { MailboxType } from 'owa-graph-schema';

export type FolderInfo = {
    folderId: string;
    mailboxType: MailboxType;
    principalSMTPAddress: string;
};

export default function getFolderInfoForRetentionPolicy(tableView: TableView): FolderInfo {
    let folderId;
    let mailboxType;
    let principalSMTPAddress;
    if (tableView && isGroupTableQuery(tableView.tableQuery)) {
        folderId = null; // No folder id needs to be set for groups
        mailboxType = 'GroupMailbox';
    } else {
        const tableViewFolderId = getFolderIdFromTableView(tableView);
        const folder = tableViewFolderId && getFolderTable().get(tableViewFolderId);
        if (!folder) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (27,13): Type 'null' is not assignable to type 'FolderInfo'.
            // @ts-expect-error
            return null;
        }

        folderId = folder.distinguishedFolderType || folder.id;
        mailboxType = folder.mailboxInfo.type;
        principalSMTPAddress = folder.mailboxInfo.mailboxSmtpAddress;
    }

    return {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (39,9): Type 'string | null' is not assignable to type 'string'.
        // @ts-expect-error
        folderId,
        mailboxType,
        principalSMTPAddress,
    };
}
